export default __webpack_public_path__ + "exp-icon3df2f1a.png";